import React from 'react';
import { Link } from 'react-router-dom';
import { TEST_IDS } from '../../constants/testIds';

const AlexaBadge = () => (
  <Link
    to="/alexa"
    data-testid="home-alexa-badge"
    className="mt-6 inline-flex items-center gap-2 hairline px-4 py-2 font-mono-r text-[10px] tracking-[0.35em] uppercase hover:bg-white hover:text-black transition-colors duration-300"
    aria-label="Now available on Alexa — open the Alexa page"
  >
    <span aria-hidden="true">✓</span>
    <span>Now on Alexa</span>
  </Link>
);

export default function HomeHero({ alexaLive }) {
  return (
    <div className="w-full flex flex-col items-center pt-4">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70 mb-6">
        ::  Independent Internet Radio  ::
      </div>

      <h1 className="font-display text-[20vw] sm:text-[16vw] md:text-[7rem] lg:text-[9rem] xl:text-[10rem] leading-[0.85]">
        OSO
        <br />
        LONDON
      </h1>

      {alexaLive && <AlexaBadge />}

      <p
        data-testid={TEST_IDS.homeTagline}
        className="mt-8 max-w-xl font-mono-r text-sm md:text-base leading-relaxed opacity-85"
      >
        A 24/7 broadcast from the corners of the city — house, dub, garage,
        jazz, broken beat and whatever else feels right tonight.
      </p>

      <Link
        to="/listen"
        data-testid={TEST_IDS.homeHeroPlay}
        className="mt-10 inline-block hairline px-10 py-4 font-mono-r text-xs tracking-[0.4em] uppercase hover:bg-white hover:text-black transition-colors duration-300"
      >
        ▶ Tune In Live
      </Link>
    </div>
  );
}
